module.exports = __webpack_public_path__ + "img/girl_default_avatar.f20fdb52.png";